<app-section-grid *ngIf="!embeddedMode" [subSection]="'Create Feed Category'"></app-section-grid>

<app-stepper-grid *ngIf="!embeddedMode"></app-stepper-grid>

<div 
  class="relative w-full max-w-4xl mx-auto p-10 bg-white rounded-3xl mb-5"
  [class.border]="hasBorder"
  [class.border-gray-200]="hasBorder">

    <form [formGroup]="rssFeedForm" (ngSubmit)="onSubmit()">
        <!-- Header -->
        <div class="text-center mb-10">
            <h1 class="text-3xl font-bold text-gray-800 tracking-tight">Feed Category Details</h1>
            <p class="mt-2 text-gray-500">Enter category details below</p>
        </div>

        <!-- Centered fields block -->
        <div class="w-full max-w-2xl mx-auto flex flex-col gap-6">

            <!-- Name -->
            <div>
                <label class="block text-sm font-semibold text-gray-700 mb-2">📰 Title <small
                        class="text-red-300">(required)</small></label>
                <textarea formControlName="feed" rows="1" (keydown.enter)="$event.preventDefault()"
                    placeholder="Enter Category Name..." class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>

                <div *ngIf="rssFeedForm.get('feed')?.touched && rssFeedForm.get('feed')?.invalid"
                    class="mt-1 text-xs text-red-500">
                    <span *ngIf="rssFeedForm.get('feed')?.hasError('required')">
                        Category name is required.
                    </span>
                </div>
            </div>

            <!-- URL -->
            <div>
                <label class="block text-sm font-semibold text-gray-700 mb-2">🔗 Url Feed <small
                        class="text-gray-400">(optional)</small></label>
                <textarea formControlName="url" rows="1" (keydown.enter)="$event.preventDefault()"
                    placeholder="https://example.com" class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
            </div>

            <!-- Site -->
            <div>
                <label class="block text-sm font-semibold text-gray-700 mb-2">🌐Social Page/Site</label>
                <select formControlName="ms_contentsite_id" [disabled]="!!contentSiteId"
                    class="cursor-pointer w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700">
                    <option value="" disabled>Select social page/site</option>

                    <option *ngFor="let site of contentSites" [value]="site.ID"
                        [disabled]="site.isApproved !== 'Approved' || site.Domain === 'default' || site.siteUrl === 'default'">
                        {{ site.Domain || 'Default site #' + site.ID }}
                    </option>
                </select>
                <p *ngIf="onlyDefaultSite" class="text-xs text-gray-500 mt-1">
                    Default/null site is enforced.
                </p>

                <div *ngIf="rssFeedForm.get('ms_contentsite_id')?.touched && rssFeedForm.get('ms_contentsite_id')?.invalid"
                    class="mt-1 text-xs text-red-500">
                    <span *ngIf="rssFeedForm.get('ms_contentsite_id')?.hasError('required')">
                        Site domain is required.
                    </span>
                </div>
            </div>

            <!-- Switchboard Template Name -->
            <div>
                <label class="block text-sm font-semibold text-gray-700 mb-2">🖼️ Switchboard Template <small
                        class="text-gray-400">(optional)</small></label>
                <textarea formControlName="switchboard_template_name" rows="1" (keydown.enter)="$event.preventDefault()"
                    placeholder="Enter template name..." class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
               focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
            </div>

            <!-- Toggles (kept functional, non-material) -->
            <div class="flex flex-col md:flex-row justify-between items-center gap-4 pt-2">
                <div *ngIf="showAiGeneratedToggle" class="flex items-center gap-3">
                    <input id="ai_generated" type="checkbox" formControlName="ai_generated"
                        (change)="onAiGeneratedChange($event)" class="h-5 w-5 cursor-pointer accent-blue-600" />
                    <label for="ai_generated" class="text-sm font-semibold text-gray-700">AI Generated</label>
                </div>

                <!-- <div class="flex items-center gap-3">
                    <input id="status" type="checkbox" formControlName="status" (change)="onStatusChange($event)"
                        class="h-5 w-5 cursor-pointer accent-blue-600" />
                    <label for="status" class="text-sm font-semibold text-gray-700">Active</label>
                </div> -->
            </div>

             <app-submit-grid></app-submit-grid>

        </div>

    </form>

</div>

<app-footer-grid *ngIf="!embeddedMode"></app-footer-grid>
